import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";
@Injectable({
  providedIn: "root",
})
export class ShowOnlyFavoritesService {
  private storage = inject(WebStorage);
  showOnlyFavoritesSubject = new BehaviorSubject<boolean>(
    this.storage.favoriteProductsOnly,
  );
  showOnlyFavoritesStatus$ = this.showOnlyFavoritesSubject.asObservable();

  setOnlyFavoritesStatus(status: boolean) {
    this.storage.favoriteProductsOnly = status;
    this.showOnlyFavoritesSubject.next(this.storage.favoriteProductsOnly);
  }
}
